import { render, staticRenderFns } from "./LoginSupportFooterPositioned.vue?vue&type=template&id=68d5a537&scoped=true"
import script from "./LoginSupportFooterPositioned.vue?vue&type=script&lang=js"
export * from "./LoginSupportFooterPositioned.vue?vue&type=script&lang=js"
import style0 from "./LoginSupportFooterPositioned.vue?vue&type=style&index=0&id=68d5a537&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d5a537",
  null
  
)

export default component.exports